import {
  IconArrowsSort,
  IconSortAscending,
  IconSortDescending,
  type Icon,
} from "@tabler/icons-react";
import { Button } from "@altimateai/lego";
import { cn } from "@/lib/utils";

interface SortIconProps {
  /** Current sort state for DataTable - can be "asc" | "desc" | false */
  sorting?: "asc" | "desc" | false;
  /** Direct click handler - caller handles toggle logic (used by DataTable/TanStack) */
  onSort?: (e: React.MouseEvent) => void;
}

const SORT_ICONS: Record<string, Icon> = {
  "": IconArrowsSort,
  asc: IconSortAscending,
  desc: IconSortDescending,
};

const SortIcon = ({ sorting, onSort }: SortIconProps) => {
  const currentValue = sorting === false ? "" : (sorting ?? "");

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    onSort?.(e);
  };

  // aria-label indicates the NEXT action (for screen readers)
  const getAriaLabel = () => {
    if (currentValue === "asc") return "Sort descending";
    if (currentValue === "desc") return "Clear sort";
    return "Sort ascending";
  };

  // title (tooltip) describes the current state
  const getTitle = () => {
    if (currentValue === "asc") return "Sorted Ascending";
    if (currentValue === "desc") return "Sorted Descending";
    return "Not Sorted";
  };

  const Icon = SORT_ICONS[currentValue] || IconArrowsSort;

  return (
    <Button
      variant="ghost"
      size="icon"
      className={cn("al-h-6 al-w-6", !!currentValue && "al-text-primary")}
      onClick={handleClick}
      aria-label={getAriaLabel()}
      title={getTitle()}
    >
      <Icon size={16} />
    </Button>
  );
};

export default SortIcon;
